<template>
  <div id="tradingRewards">
    <div class="content_box">
      <div class="inner">
        <div class="contact_title">
          <h2>{{ clientPortalSettings.pageTitle || clientPortalSettings.title }}</h2>
          <p></p>
        </div>

        <!-- Tier Box -->
        <el-row justify="center" v-if="rewardPayoutEnabled">
          <el-col :md="{ span: 10, offset: 7 }" :xs="{ span: 24, offset: 0 }" class="tier_box md:px-10 md:py-7.5">
            <el-row v-if="showTiered"
              ><el-col :md="12" :xs="12"
                ><p>
                  {{
                    optIn
                      ? $t('promotion.tradingRewards.currentTier', { number: currentTier })
                      : $t('promotion.tradingRewards.noTier')
                  }}
                </p> </el-col
              ><el-col :md="12" :xs="12" class="text-right"
                ><el-button type="text" @click="openTiersDialog()"
                  >{{ $t('promotion.tradingRewards.allTiers') }} ></el-button
                ></el-col
              ></el-row
            >
            <el-row v-else>
              <h1>
                {{
                  isUsingTotalProfit
                    ? $t('promotion.tradingRewards.milestone')
                    : $t('promotion.tradingRewards.requirements')
                }}
              </h1>
            </el-row>
            <el-row class="mt-5 sub_menu" :gutter="35"
              ><el-col :md="12" :xs="24"
                ><p class="grey_text">
                  {{
                    `${$t(`promotion.tradingRewards.rqmtTitle.${tradingMetric}`)} (${$t(
                      'promotion.tradingRewards.closedTrades'
                    )}): `
                  }}
                </p>
                <p class="mt-3">
                  <span class="sub_menu_amount">{{ `${notionalVolume} ${tradingMetricMeasureWord}` }}</span>
                </p>
                <hr class="block md:hidden my-5" /></el-col
              ><el-col :md="12" :xs="24" v-if="depositType != null"
                ><p class="grey_text">{{ $t(`promotion.tradingRewards.${depositType}`) }}:</p>
                <p class="mt-3">
                  <span class="sub_menu_amount">{{
                    `${depositAmount} ${$t('promotion.tradingRewards.usdSign')}`
                  }}</span>
                  <span class="sub_menu_amount_2"
                    >/ {{ `${minimumDeposit} ${$t('promotion.tradingRewards.usdSign')}` }}</span
                  >
                </p></el-col
              ></el-row
            >
          </el-col>
        </el-row>

        <!-- Intro Text -->
        <el-row justify="center" class="my-7">
          <el-col>
            <p class="intro_text vhtml_component" v-html="clientPortalSettings.description1"></p>
          </el-col>
        </el-row>

        <!-- Meta Box -->
        <el-row justify="center">
          <el-col>
            <div class="meta_box py-7.5 xs:my-0">
              <!-- Opt in -->
              <el-row v-if="!optIn">
                <el-col>
                  <p class="mb-6 vhtml_component" v-html="clientPortalSettings.description2"></p>
                </el-col>
                <el-col :md="{ span: 10, offset: 7 }" :xs="{ span: 24, offset: 0 }">
                  <TermsAndConditions
                    :isAgreeTnc.sync="isAgreeTnc"
                    :showError.sync="showTncError"
                    :tncUrl="clientPortalSettings.tncLink"
                    v-if="!expired"
                  />
                  <el-button
                    round
                    type="primary"
                    data-testid="OptInNow"
                    @click="handlerOptInNowChange()"
                    v-if="!expired"
                  >
                    {{ $t('promotion.tradingRewards.optInNow') }}
                  </el-button></el-col
                >
              </el-row>

              <!-- Rewards Account -->
              <el-row v-else
                ><el-col> <p class="mb-6 vhtml_component" v-html="clientPortalSettings.description3"></p> </el-col
                ><el-col
                  :md="{ span: mt4Account ? 8 : 10, offset: mt4Account ? 8 : 7 }"
                  :xs="{ span: 24, offset: 0 }"
                  class="reward_box"
                  v-if="!isUsingTotalProfit && !expired"
                >
                  <div class="flex flex-col justify-between items-center" :class="{ 'md:flex-row': !mt4Account }">
                    <div :class="{ rewardAccount: !mt4Account }">
                      {{ $t('promotion.tradingRewards.rewardAccount') }}:
                      <span class="blue_text" v-if="mt4Account">{{ mt4Account }}</span>
                      <span class="acc_invalid" v-if="optIn && !mt4Account"
                        >{{ $t('promotion.tradingRewards.invalid') }}
                        <el-popover
                          width="300"
                          :content="$t('promotion.tradingRewards.invalidDesc')"
                          placement="bottom-start"
                          trigger="hover"
                        >
                          <span slot="reference" class="popover_icon el-icon-warning-outline blue_text"></span>
                        </el-popover>
                      </span>
                    </div>

                    <div v-if="optIn && !mt4Account">
                      <el-button round type="primary" @click="onClickSelectAccount()">{{
                        $t('promotion.tradingRewards.selectAccount')
                      }}</el-button>
                    </div>
                  </div>
                </el-col>

                <!-- TNC -->
                <el-col class="mt-5" v-if="optIn && !expired">
                  <el-button @click="openTncLink()" data-testid="tnc" type="text" size="large">{{
                    $t('promotion.tradingRewards.tncLink')
                  }}</el-button></el-col
                >
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- Reward History -->
      <el-row v-if="rewardPayoutEnabled">
        <div class="contact_title">
          <h2>{{ $t('promotion.tradingRewards.rewardHistory') }}</h2>
          <p></p>
        </div>
      </el-row>

      <!-- Component -->
      <RewardHistory :tradingMetric="tradingMetric" v-if="rewardPayoutEnabled" />
    </div>

    <SelectAccountDialog
      :redeemableAccountOptions="redeemableAccountOptions"
      :selectAccountDialogVisible.sync="selectAccountDialogVisible"
      @submit="submitAccount"
    />

    <TierDetailsDialog
      :rewardTiers="rewardTiers"
      :tiersDialogVisible.sync="tiersDialogVisible"
      :depositType="depositType"
      :tradingMetric="tradingMetric"
      :currentTier="currentTier"
      :rewardType="rewardType"
      @close="closeTiersDialog"
    />
  </div>
</template>

<script>
import RewardHistory from '@/components/tradingRewards/RewardHistory';
import TierDetailsDialog from '@/components/tradingRewards/TierDetailsDialog';
import SelectAccountDialog from '@/components/tradingRewards/SelectAccountDialog.vue';
import TermsAndConditions from '@/components/promotion/TermsAndConditions.vue';
import { tradingRewardsEnum } from '@/constants/promotion';
import { apiCampaignInfo, apiOptInAcc, apiRedeemableAcc, apiCampaignOpt } from '@/resource';
import rounding from '@/util/rounding';

export default {
  name: 'tradingRewards',
  components: { RewardHistory, TierDetailsDialog, SelectAccountDialog, TermsAndConditions },
  data() {
    return {
      optIn: false,
      expired: false,
      isAgreeTnc: false,
      showTncError: false,
      depositAmount: 0,
      notionalVolume: 0,
      clientPortalSettings: {},
      rewardHistory: [],
      minimumDeposit: 0,
      minimumTrade: 0,
      tiersDialogVisible: false,
      rewardCalculationType: tradingRewardsEnum.CUMULATIVE,
      currentTier: 0,
      rewardTiers: [],
      mt4Account: null,
      redeemableAccountOptions: [],
      selectAccountDialogVisible: false,
      depositType: null,
      rewardType: null,
      tradingMetric: null,
      rewardPayoutEnabled: true
    };
  },
  watch: {
    $route(to, from) {
      this.getDetails();
      this.getRedeemableAccounts();
    }
  },
  computed: {
    campaignID() {
      return this.$route.params.campaignId || null;
    },
    langUsed() {
      return this.$store.state.common.lang;
    },
    showTiered() {
      return this.rewardCalculationType == tradingRewardsEnum.TIERED || false;
    },
    isUsingTotalProfit() {
      return this.tradingMetric == tradingRewardsEnum.PROFITORDER;
    },
    tradingMetricMeasureWord() {
      switch (this.tradingMetric) {
        case tradingRewardsEnum.TRADINGLOTS:
          return this.$t('promotion.tradingRewards.lots');
        default:
          return this.$t('promotion.tradingRewards.usdSign');
      }
    }
  },
  methods: {
    createNewVPS() {
      this.dialogVisible = true;
    },
    // async getData() {
    //   const historyData = await apiVpsHistory();
    //   if (Array.isArray(historyData.data.data)) {
    //     this.tableData = historyData.data.data;
    //   }
    //   const vpsGetSave = await apiVpsGetSaveChange();
    //   if (vpsGetSave.data.code === 0) this.isSaveChange = vpsGetSave.data.data;
    // },
    saveChange() {
      if (!this.isAgreeTnc) {
        this.showCheckboxError = true;
      } else {
        this.showCheckboxError = false;
        apiVpsSetSaveChange();
        this.isSaveChange = true;
      }
    },
    openTiersDialog() {
      this.tiersDialogVisible = true;
    },
    closeTiersDialog() {
      this.tiersDialogVisible = false;
    },
    openTncLink() {
      window.open(this.clientPortalSettings.tncLink, '_blank');
    },
    handlerOptInNowChange() {
      if (this.isAgreeTnc) {
        this.showTncError = false;
        this.onClickSelectAccount();
      } else {
        this.showTncError = true;
      }
    },
    onClickSelectAccount() {
      if (this.tradingMetric == tradingRewardsEnum.PROFITORDER) {
        apiCampaignOpt(this.campaignID, true).then(resp => {
          if (resp.data.data) {
            this.getDetails();
          } else {
            this.$message({
              message: this.$t('common.field.failed'),
              type: 'error',
              duration: 5000
            });
          }
        });
      } else if (this.redeemableAccountOptions.length > 0) {
        this.selectAccountDialogVisible = true;
      } else {
        this.$message({
          message: this.$t('promotion.tradingRewards.createAccountNote'),
          type: 'error',
          duration: 5000
        });
      }
    },
    getDetails() {
      if (this.campaignID == null) return;

      apiCampaignInfo(this.campaignID, this.langUsed)
        .then(resp => {
          if (resp.data.code === 0) {
            if (resp.data.data) {
              this.depositAmount = this.roundValue(resp.data.data.totalDeposit) || 0;
              this.notionalVolume = this.roundValue(resp.data.data.totalTrade) || 0;
              this.rewardHistory = resp.data.data.rewards || [];
              this.minimumDeposit = resp.data.data.minimumDeposit || 0;
              this.minimumTrade = resp.data.data.minimumTrade || 0;
              this.optIn = resp.data.data.optIn || false;
              this.expired = resp.data.data.expired || false;
              this.depositType = resp.data.data.depositType;
              this.rewardType = resp.data.data.rewardType;
              this.currentTier = resp.data.data.currentTier ? parseInt(resp.data.data.currentTier) : 0;
              this.mt4Account = resp.data.data.mt4Account || null;
              this.rewardTiers = resp.data.data.rewardTiers || [];
              this.rewardCalculationType = resp.data.data.rewardCalculationType || tradingRewardsEnum.CUMULATIVE;
              this.rewardPayoutEnabled = resp.data.data.rewardPayoutEnabled || false;
              this.tradingMetric = resp.data.data.tradingMetric || tradingRewardsEnum.PROFITORDER;
              this.clientPortalSettings = {
                ...resp.data.data.clientPortalSettings,
                document: resp.data.data.clientPortalSettings.document
                  ? `${window.location.origin}/api${resp.data.data.clientPortalSettings.document}`
                  : ''
              };
            }
          }
        })
        .catch(e => {
          this.$message({
            message: this.$t('common.field.failed'),
            type: 'error',
            duration: 5000
          });
        });
    },
    roundValue(value) {
      if (!value) return 0;
      return rounding(Math.floor, value, 2);
    },
    getRedeemableAccounts() {
      if (this.campaignID == null) return;
      apiRedeemableAcc(this.campaignID)
        .then(resp => {
          if (resp.data.code === 0) {
            if (resp.data.data) {
              this.redeemableAccountOptions = resp.data.data || [];
            }
          }
        })
        .catch(e => {
          this.$message({
            message: this.$t('common.field.failed'),
            type: 'error',
            duration: 5000
          });
        });
    },
    submitAccount(selectAccount) {
      if (this.campaignID == null) return;
      apiOptInAcc({
        campaignId: parseInt(this.campaignID),
        accountMt4Dto: {
          mt4Account: selectAccount
        }
      }).then(resp => {
        resp.data.data = true;
        if (resp.data.data) {
          this.$message({
            message: this.$t('promotion.depositBonus.optIn'),
            type: 'success',
            duration: 5000
          });
          this.selectAccountDialogVisible = false;
          this.getDetails();
        } else {
          this.$message({
            message: this.$t('common.field.failed'),
            type: 'error',
            duration: 5000
          });
        }
      });
    }
  },
  mounted() {
    this.getDetails();
    this.getRedeemableAccounts();
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/promotion/tabs.scss';
@import '@/assets/css/pages/tradingRewards.scss';
</style>

<style>
.el-popover {
  background-color: #0051ff;
  color: white;
  font-size: 12px;
  border-radius: 10px;
}

.el-popper[x-placement^='bottom'] .popper__arrow::after {
  border-color: transparent transparent #0051ff transparent;
}

.el-dialog {
  margin-top: auto !important;
}
</style>
